export default "__VITE_ASSET__XTA4U53y__"